import {
  KYC_REDIRECT_URL,
  KYCDispatchType,
} from "../../actions/kyc/KYCActionType";

export interface IDefaultState {
  redirectUrl?: string;
}

const defaultState: IDefaultState = {};

const KYCReducer = (
  // eslint-disable-next-line no-restricted-globals
  state: IDefaultState = defaultState,
  action: KYCDispatchType
): IDefaultState => {
  switch (action.type) {
    case KYC_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload.redirectUrl,
      };
    default:
      return state;
  }
};

export default KYCReducer;
